import { render, staticRenderFns } from "./AssessmentExtraPayment.vue?vue&type=template&id=14896ad9&scoped=true"
import script from "./AssessmentExtraPayment.vue?vue&type=script&lang=js"
export * from "./AssessmentExtraPayment.vue?vue&type=script&lang=js"
import style0 from "./AssessmentExtraPayment.vue?vue&type=style&index=0&id=14896ad9&prod&scoped=true&lang=css"
import style1 from "./AssessmentExtraPayment.vue?vue&type=style&index=1&id=14896ad9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14896ad9",
  null
  
)

export default component.exports